import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../../utils/validate-payload.js';
import { registerRecentQueriesPayloadDefinition, } from '../../recent-queries/recent-queries-actions.js';
export const clearRecentQueries = createAction('commerce/recentQueries/clear');
export const registerRecentQueries = createAction('commerce/recentQueries/register', (payload) => validatePayload(payload, registerRecentQueriesPayloadDefinition));
